/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import buildIndividuUpdatePayload from './buildIndividuUpdatePayload';

/**
 * Construit le payload de mise à jour de l'onglet « ENFANT » du panel des
 * personnes de la fiche acte, envoyé via `service.update`
 * (PUT `/numerisation-actes/naissance/{identifiant}`).
 *
 * Seul l'état civil est éditable dans cette modal (la naissance de l'enfant est
 * éditée depuis le panel « EVENEMENT ») ; les champs `naissance*` lus sont
 * renvoyés inchangés, cf. `buildIndividuUpdatePayload`.
 *
 * @param identifiant Identifiant de l'**acte** : c'est lui qui construit l'URL du PUT.
 */
const buildEnfantUpdatePayload = (
  identifiant: number,
  enfant: Record<string, any> | undefined,
  data: Record<string, any>,
) => ({
  identifiant,
  enfant: buildIndividuUpdatePayload(enfant, data),
});

export default buildEnfantUpdatePayload;
